module.exports = {"views.checkoutSuccessMeditationStudio.success.heading":"¡Éxito!","views.checkoutSuccessMeditationStudio.success.body":"Tu suscripción ha sido activada exitosamente."}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/es/views/CheckoutSuccessMeditationStudio.json
// module id = 749
// module chunks = 0